import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';

const GetAllDistrictUserDailyTimeEntryGroups = gql`
  query GetAllDistrictUserDailyTimeEntryGroupsQuery($startDate: String!, $endDate: String!, $districtId: Int, $departmentId: Int) {
    all_user_daily_time_entry_groups(start_date: $startDate, end_date: $endDate, district_id: $districtId, department_id: $departmentId) {
      time_entry_group {
        interval {
          dayOfWeek: day_of_week
          display
          iso8601
        }
      }
      edges {
        node {
          userDailyTimeEntries: user_daily_time_entries {
            workedHours: worked_hours {
              to_string
              to_hours
            }
            date {
              iso8601
            }
            hasTimeEntries: has_time_entries
            paidPerDiem: paid_per_diem
            timeEntries: time_entries {
              ticket_number {
                number
                id
                ticket {
                  id
                  job {
                    id
                  }
                }
              }
              total_hours {
                to_hours
              }
            }
            ticketNumbers: ticket_numbers {
              id
              number
              ticket {
                id
                job {
                  id
                }
              }
            }
          }
          user {
            id
            fullname
            lastname
          }
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allDistrictUserDailyTimeEntryGroups = querySelector(data, '$.all_user_daily_time_entry_groups.edges[*].node', []);
  const [interval] = querySelector(data, '$.all_user_daily_time_entry_groups.time_entry_group.interval', []);

  return {
    ...ownProps,
    data,
    interval,
    allDistrictUserDailyTimeEntryGroups,
  };
};

const queryGetAllDistrictUserDailyTimeEntryGroupsData = graphql(GetAllDistrictUserDailyTimeEntryGroups, {
  props: marshallData,
});

export const queryGetAllDistrictUserDailyTimeEntryGroupsDataGQL = compose(
  queryGetAllDistrictUserDailyTimeEntryGroupsData,
  queryMetaHandler,
);
